<template>
	<c-dialog ref="dialog" title="生产计划详情" mode="slide" width="100vw-300" enable-flex mask-close :button="false">
		<template #head>
			<div v-if="detailData.order_code" class="m-detail-tag flex-center-cross">
				<label>{{detailData.order_code}}</label>
				<c-state dict="orderStateDic" tag :value="detailData.plan_state"></c-state>
			</div>
		</template>
		
		<module>
			<module-col size="350">
				<c-detail class="m-detail-form">
					<c-detail-item label="计划二维码">
						<c-qrcode :value="detailData.h5_web" size="100"></c-qrcode>
					</c-detail-item>
					<c-detail-item label="计划开始时间">
						{{detailData.plan_start_date}}
					</c-detail-item>
					<c-detail-item label="计划结束时间">
						{{detailData.plan_end_date}}
					</c-detail-item>
					<c-detail-item label="计划数">
						<b>{{detailData.plan_count}}</b>
					</c-detail-item>
					<c-detail-item label="已排产数">
						<b>{{detailData.scheduling_count}}</b>
					</c-detail-item>
					<c-detail-item label="排产进度">
						<c-progress :rate="[detailData.scheduling_count, detailData.plan_count]" :color="((detailData.scheduling_count/detailData.plan_count)>=1||detailData.plan_count==0) ?'green':'blue'"></c-progress>
					</c-detail-item>
					<c-detail-item label="已完工数">
						<b>{{detailData.scheduling_ok_count}}</b>
					</c-detail-item>
					<c-detail-item label="完工进度">
						<c-progress :rate="[detailData.scheduling_ok_count, detailData.plan_count]" :color="((detailData.scheduling_ok_count/detailData.plan_count)>=1||detailData.plan_count==0) ?'green':'blue'"></c-progress>
					</c-detail-item>
					<c-detail-item label="关联工单数">
						{{detailData.work_count}}
					</c-detail-item>
					<c-detail-item label="创建人">
						{{detailData.create_user_realname}}
					</c-detail-item>
					<c-detail-item label="创建时间">
						{{detailData.create_date}}
					</c-detail-item>
					<custom-detail work-type="2" :data="detailData.custom_fields_value_json"></custom-detail>
				</c-detail>
			</module-col>

			<module-col tab-type="border-tab">
				<module-tab name="生产计划单">
					<div class="m-detail-box">
						<c-title>产品明细</c-title>
						<custom-table ref="productTable" view-id="20006" readonly>
							<!--产品来源-->
							<template #product_source="{data}">
								<c-state dict="productSourceName" :value="data.product_source"></c-state>
							</template>
							
							<template #product_type="{data}">
								<c-state dict="productTypeName" :value="data.product_type"></c-state>
							</template>
						</custom-table>
						
						<c-title>已排产产品</c-title>
						<custom-table ref="workTable" view-id="20003" readonly>
							<c-table-column
								type="tree"
								label="工单层级"
								width="300"
								name="childProduct"
								level-limit="5"
								:leaf-node="({data}) => !data.childProduct"
							>
								<template #default="{data}">
									{{data.product_name}}
								</template>
							</c-table-column>
							
							<!--产品来源-->
							<template #product_source="{data}">
								<c-state dict="productSourceName" :value="data.product_source"></c-state>
							</template>
							
							<!--产品类型-->
							<template #product_type="{data}">
								<c-state dict="productTypeName" :value="data.product_type"></c-state>
							</template>
							
							<!--工单进度-->
							<template #process_rate="{data}">
								<process-rate :key="data._timestamp" :id="data.id"></process-rate>
							</template>
							
							<!--工单进度%-->
							<template #work_progress="{data}">
								<c-progress :rate="[data.ok_count, data.plan_count]" :color="((data.ok_count/data.plan_count)>=1||data.plan_count==0) ?'green':'blue'"></c-progress>
							</template>
							
							<!--工单明细进度%-->
							<template #work_detail_progress="{data}">
								<c-progress :rate="[data.task_fine_count, data.task_plan_count||1]" :color="((data.task_fine_count/data.task_plan_count)>=1||data.task_plan_count==0) ?'green':'blue'"></c-progress>
							</template>
							
							<!--计划时间-->
							<template #plan_date="{data}">
								{{data.plan_start_date}} - {{data.plan_end_date}}
							</template>
							
							<!--工单状态-->
							<template #work_state="{data}">
								<c-state dict="orderStateDic" tag :value="data.work_state"></c-state>
							</template>
							
							<!--优先级-->
							<template #priority="{data}">
								<c-state dict="priorityDic" tag :value="data.priority"></c-state>
							</template>
							
							<!--工期状态-->
							<template #plan_date_state="{data}">
								<c-state type="expectedDate" :value="data.expected_date"></c-state>
							</template>
						</custom-table>
					</div>
				</module-tab>
			</module-col>
		</module>
	</c-dialog>
</template>

<script>
	export default {
		name: 'planDetail',

		props: {
			id: [String, Number]
		},
		
		data() {
			return {
				detailData: {}
			}
		},

		methods: {
			open() {
				this.request({
					url: '/plan/overview',
					data: {
						id: this.id
					},
					loading: true,
					success: data => {
						this.detailData = data.detailInfo;
						this.$refs.productTable.init();
						this.$refs.workTable.init();
						this.$refs.productTable.$refs.list.setData(data.productList);
						this.$refs.workTable.$refs.list.setData(data.workList);
						this.$refs.dialog.open();
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>